import React from "react";

import Tag, { PropsTag, TagSettings } from "./Tag/Tag";

interface PropsTagsList {
  tagList: PropsTag[];
}
const TagsList: React.FC<PropsTagsList> = (props: PropsTagsList) => {
  return (
    <>
      {props.tagList.map((tags: PropsTag, index: number) => (
        <li key={index}>
          <Tag {...tags} />
        </li>
      ))}
    </>
  );
};

export default TagsList;
